import React, { useState, useCallback, useEffect } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import { getSignedUrl } from "@/services/media";

const SignedLink = ({ children, staticUrl, fullscreen, style }) => {
  const [lastStaticUrl, setLastStaticUrl] = useState(staticUrl);
  const [signedUrl, setSignedUrl] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);

  const onClick = useCallback(async () => {
    let currentUrl = signedUrl;

    if (expirationDate !== null) {
      const now = moment();
      const expirationMoment = moment(expirationDate);
      if (expirationMoment.isBefore(now)) {
        currentUrl = null;
      }
    }

    if (currentUrl === null) {
      try {
        const staticUrlObj = new URL(lastStaticUrl);
        currentUrl = await getSignedUrl(staticUrlObj.pathname.replace("/", ""));

        setSignedUrl(currentUrl);

        const url = new URL(currentUrl);
        const params = new URLSearchParams(url.search);
        const expires = Number(params.get("Expires"));
        if (!isNaN(expires)) {
          setExpirationDate(expires * 1000);
        }
      } catch (error) {
        return;
      }
    }

    window.open(currentUrl, "_blank", fullscreen ? "fullscreen=yes" : undefined);
  }, [lastStaticUrl, signedUrl, expirationDate]);

  useEffect(() => {
    if (staticUrl !== lastStaticUrl) {
      setLastStaticUrl(staticUrl);
      setSignedUrl(null);
    }
  }, [staticUrl, lastStaticUrl]);

  return (
    <div role="button" onClick={onClick} style={style}>
      {staticUrl ? children : <LoadingOutlined />}
    </div>
  );
};

export default SignedLink;
